import { useRouter } from 'next/router';
import { useCallback } from 'react';

/**
 *
 *  ( See ActiveNavLink if that works better )
 *
 * @returns
 */
export function useActiveRoute() {
    const router = useRouter();

    /**
     * Checks only base of the URL path to mark a menu header as active
     *
     * Examples:
     * "/" === index
     * "quiz_templates" === "/quiz_templates" || "/quiz_templates/...any/...any"
     */
    const isActivePath = useCallback(
        (pathsCheck: string[]) => {
            let pathName: string | string[] = router.pathname;

            if (pathName === '/') {
                return pathsCheck.includes('/');
            }
            pathName = router.pathname.trim().split('/');
            return pathsCheck.includes(pathName?.[1]);
        },
        [router],
    );

    return isActivePath;
}
